/*
 *
 *  sagas
 *
 */

import { call, take, put, race, select, all, delay } from "redux-saga/effects"

import {
  LOAD_RECORD,
  LOAD_RECORDS,
  CREATE_RECORD,
  UPDATE_RECORD,
  DELETE_RECORD,
  LOAD_RECORDS_META_DATA,
  UPDATE_STATUS,
  LEAD_STATUS,
} from "./constants"

import {
  loadRecords as loadRecordsAction,
  loadRecordsSuccess,
  loadRecordsError,
  loadRecordSuccess,
  loadRecordError,
  createRecordSuccess,
  createRecordError,
  updateRecordSuccess,
  updateRecordError,
  deleteRecordSuccess,
  deleteRecordError,
  loadRecordsCacheHit,
  // loadRecordsMetaData as loadRecordsMetaDataAction,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  updateStatusSuccess,
  updateStatusError,
  leadStatusSuccess,
  leadStatusError,
} from "./actions"

import {
  loadRecords,
  loadRecordsMetaData,
  loadRecord,
  createRecord,
  updateRecord,
  deleteRecord,
  updateStatus,
  leadStatus,
} from "./remotes"

import { selectRecords, selectUpdateTimestamp } from "./selectors"

// import { selectSession } from "../session/selectors"
// import { roleIds } from "../../helpers/tools"

function* loadRecordsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_RECORDS),
    })

    const { explicitLoad } = load
    const { invalidateCache, filter } = explicitLoad || {}
    const lastLoad = yield select(selectUpdateTimestamp())
    const currentTimestamp = Math.floor(Date.now() / 1000)
    const VALID_CACHE_DIFF = -30
    //yield put(loadRecordsMetaDataAction())// Calling Dropdown API's
    if (explicitLoad) {
      if (
        !invalidateCache &&
        lastLoad &&
        lastLoad - currentTimestamp > VALID_CACHE_DIFF
      ) {
        yield put(loadRecordsCacheHit())
      } else {
        try {
          const result = yield call(loadRecords, filter)
          console.log(result, "result for unassigned")
          // const filteredData =
          //   (result &&
          //     result.data &&
          //     result.data.length > 0 &&
          //     result.data.filter(
          //       (row) =>
          //         row &&
          //         row.processStatus &&
          //         row.processStatus.processStatusId === "PS1"
          //     )) ||
          //   []
          if (result) {
            yield put(loadRecordsSuccess(result.data))
          } else {
            yield put(loadRecordsError("Fetch Records Failed"))
          }
        } catch (error) {
          yield put(
            loadRecordsError(
              (error && error.response && error.response.message) ||
                "Fetch Records Failed"
            )
          )
        }
      }
    }
  }
}

function* loadRecordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const loadRequest = yield race({
      request: take(LOAD_RECORD),
    })
    const { request } = loadRequest

    if (request) {
      const { id } = request
      try {
        const record = yield call(loadRecord, id)

        let recordsMetaData = {}
        if (record) {
          // Delays the dispatch of loadRecordSuccess untill the store is populated with an initial list of records.
          while (true) {
            // eslint-disable-line no-constant-condition
            const recordsInStore = yield select(selectRecords())
            if (recordsInStore && recordsInStore.length > 0) {
              break
            }
            yield delay(500)
          }
          yield put(loadRecordSuccess(record, recordsMetaData))
        } else {
          yield put(loadRecordError("Fetch Record Failed"))
        }
      } catch (error) {
        yield put(
          loadRecordError(
            (error && error.response && error.response.message) ||
              "Fetch Record Failed"
          )
        )
      }
    }
  }
}

function* createRecordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(CREATE_RECORD),
    })
    const { record, setSubmitting, redirect } = create || {}
    if (create) {
      yield call(setSubmitting, true)
      try {
        yield call(createRecord, record)

        yield delay(1000)
        yield put(createRecordSuccess(record, "Record Created Successfully"))
        yield delay(1000)
        yield put(
          loadRecordsAction({ status: "active" }, true)
          // loadRecordsAction({ status: "active", processStatusId: "PS1" }, true)
        )
        yield call(redirect)
      } catch (error) {
        yield put(
          createRecordError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        yield call(setSubmitting, false)
      }
    }
  }
}

function* editRecordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { edit } = yield race({
      edit: take(UPDATE_RECORD),
    })
    const { record, setSubmitting, redirect } = edit || {}
    if (edit) {
      yield call(setSubmitting, true)

      try {
        yield call(updateRecord, record)
        yield delay(1000)
        yield put(updateRecordSuccess(record, "Record Updated Successfully"))
        yield call(redirect)
      } catch (error) {
        yield put(
          updateRecordError(
            (error && error.response && error.response.message) ||
              "Update Record Failed"
          )
        )
      } finally {
        yield call(setSubmitting, false)
      }
    }
  }
}

function* deleteRecordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { del } = yield race({
      del: take(DELETE_RECORD),
    })
    const { id, setSubmitting, redirect } = del || {}
    if (del) {
      yield call(setSubmitting, true)

      try {
        yield call(deleteRecord, id)
        yield delay(1000)
        yield put(deleteRecordSuccess(id, "Record Deleted Successfully"))
        yield call(redirect)
      } catch (error) {
        yield put(
          deleteRecordError(
            (error && error.response && error.response.message) ||
              "Delete Record Failed"
          )
        )
      } finally {
        yield call(setSubmitting, false)
      }
    }
  }
}

function* loadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_RECORDS_META_DATA),
    })

    try {
      // console.log("manage lead access for company")
      // let sessionDetails
      // while (true) {
      //   // eslint-disable-line no-constant-condition
      //   const sessionInStore = yield select(selectSession())
      //   const { user = {} } = sessionInStore
      //   if (user && Object.keys(user).length > 0) {
      //     sessionDetails = sessionInStore
      //     break
      //   }
      //   yield delay(500)
      // }
      //console.log("Try company access")

      let company
      let branch

      company = yield call(loadRecordsMetaData, "company", "post")
      branch = yield call(loadRecordsMetaData, "branch", "post")

      // if (
      //   sessionDetails &&
      //   sessionDetails.user &&
      //   roleIds.includes(sessionDetails.user.roleId)
      // ) {
      //   company = yield call(loadRecordsMetaData, "company", "post")
      //   branch = yield call(loadRecordsMetaData, "branch", "post")
      // } else {
      //   company =
      //     (sessionDetails &&
      //       sessionDetails.user &&
      //       sessionDetails.user.company &&
      //       sessionDetails.user.company.length > 0 &&
      //       sessionDetails.user.company.map((_) => _.detail)) ||
      //     []
      //   branch =
      //     (sessionDetails &&
      //       sessionDetails.user &&
      //       sessionDetails.user.branch &&
      //       sessionDetails.user.branch.length > 0 &&
      //       sessionDetails.user.branch.map((_) => _.detail)) ||
      //     []
      // }
      console.log(company, "my company")
      console.log(branch, "my branch")
      const service = yield call(loadRecordsMetaData, "lead_service", "post")
      const source = yield call(loadRecordsMetaData, "source", "post")
      const subSource = yield call(loadRecordsMetaData, "sub_source", "post")
      const clientProfile = yield call(
        loadRecordsMetaData,
        "client_profile",
        "post"
      )

      console.log(subSource, "my subsource")
      const priorityStatus = yield call(loadRecordsMetaData, "priority", "post")
      const customField = yield call(
        loadRecordsMetaData,
        "custom_field",
        "post"
      )
      const country = yield call(loadRecordsMetaData, "country", "post")
      const state = yield call(loadRecordsMetaData, "state", "post")
      const city = yield call(loadRecordsMetaData, "city", "post")
      const processStatus = yield call(
        loadRecordsMetaData,
        "process_status",
        "post"
      )
      // const session = yield call(
      //   loadRecordsMetaData,
      //   "session_user_info",
      //   "get"
      // )
      // const user = session && session.data

      // const authUser = localStorage.getItem("authUser")
      // const userDetails = JSON.parse(authUser)
      // const companyDetails =
      //   userDetails && userDetails ? userDetails.company : []
      // const branchDetails = userDetails && userDetails ? userDetails.branch : []
      // const companyId = companyDetails.map((company) => company.detail._id)
      // const branchId = branchDetails.map((branch) => branch.detail._id)

      // const roleId = userDetails && userDetails ? userDetails.roleId : ""

      // console.log(companyId, "companyId auth")
      // console.log(roleId, "roleId auth")
      // console.log(branchId, "branchId auth")

      // console.log(company, "Our branch Id in dropdowns ")

      // // 61bcb7ed0e04359342e992f6

      // const companyDetailsList =
      //   company &&
      //   company.data &&
      //   company.data.length > 0 &&
      //   company.data.filter((_) => _.status === 1)
      // // const companyName = companyDetailsList.map((data) => data._id)

      // var companyIdFinal = []
      // const companyName =
      //   company &&
      //   company.data &&
      //   company.data.length > 0 &&
      //   company.data
      //     .filter(
      //       (_) =>
      //         _.status === 1 &&
      //         (roleId === "61bcb7ed0e04359342e992f6" ||
      //           roleId === "622f0d5c246a442107c8158e" ||
      //           roleId === "61bcb7ed0e04359342e992f62" ||
      //           roleId === "6394779685898637927c8f5b")
      //     )
      //     .map((c) => {
      //       return {
      //         label: c.name,
      //         value: c._id,
      //       }
      //     })

      // // var companyDetailsId =  companyName.filter((el) => {
      // //     return el !== undefined
      // //   }) || []
      // companyIdFinal = companyName

      // if (!companyIdFinal || companyIdFinal.length === 0) {
      //   const companyNameElse =
      //     company &&
      //     company.data &&
      //     company.data.length > 0 &&
      //     company.data
      //       .filter((_) => _.status === 1)
      //       .map((c) => {
      //         if (companyId && companyId.length > 0) {
      //           var companyIdCount = companyId.length
      //           // var branchDetailsIdCount = branchDetailsId.length

      //           for (let i = 0; i < companyIdCount; i++) {
      //             if (c._id === companyId[i]) {
      //               return {
      //                 label: c.name,
      //                 value: c._id,
      //               }
      //             }
      //           }
      //         }
      //       })

      //   var companyDetailsId =
      //     companyNameElse.filter((el) => {
      //       return el !== undefined
      //     }) || []

      //   companyIdFinal = companyDetailsId
      // }

      // //  const branchName =  company &&
      // //  company.data &&
      // //  company.data.length > 0 &&
      // //  company.data.filter((_) => _.status === 1)
      // // const companyName = companyDetailsList.map((data) => data._id)

      // var branchIdFinal = []
      // const branchName =
      //   branch &&
      //   branch.data &&
      //   branch.data.length > 0 &&
      //   branch.data
      //     .filter(
      //       (_) =>
      //         _.status === 1 &&
      //         (roleId === "61bcb7ed0e04359342e992f6" ||
      //           roleId === "622f0d5c246a442107c8158e" ||
      //           roleId === "61bcb7ed0e04359342e992f62" ||
      //           roleId === "6394779685898637927c8f5b")
      //     )
      //     .map((c) => {
      //       return {
      //         label: c.name,
      //         value: c._id,
      //         companyId: c.companyId,
      //       }
      //     })

      // // var companyDetailsId =  companyName.filter((el) => {
      // //     return el !== undefined
      // //   }) || []
      // branchIdFinal = branchName

      // if (!branchIdFinal || branchIdFinal.length === 0) {
      //   const branchNameElse =
      //     branch &&
      //     branch.data &&
      //     branch.data.length > 0 &&
      //     branch.data
      //       .filter((_) => _.status === 1)
      //       .map((c) => {
      //         if (branchId && branchId.length > 0) {
      //           var branchIdCount = branchId.length
      //           // var branchDetailsIdCount = branchDetailsId.length

      //           for (let i = 0; i < branchIdCount; i++) {
      //             if (c._id === branchId[i]) {
      //               return {
      //                 label: c.name,
      //                 value: c._id,
      //               }
      //             }
      //           }
      //         }
      //       })

      //   var branchDetailsId =
      //     branchNameElse.filter((el) => {
      //       return el !== undefined
      //     }) || []

      //   branchIdFinal = branchDetailsId
      // }

      // console.log(branchIdFinal, " my branchIdFinal final")

      // const branchName =
      //   branch &&
      //   branch.data &&
      //   branch.data.length > 0 &&
      //   branch.data
      //     .filter((_) => _.status === 1)
      //     .map((c) => {
      //       console.log(branchId, "Our branch Id in dropdowns ")

      //       // Loop Function Start

      //       if (
      //         roleId !== "61bcb7ed0e04359342e992f6" &&
      //         roleId !== "622f0d5c246a442107c8158e"
      //         // roleId !== "61bcb7ed0e04359342e992f62" &&
      //         // roleId !== "6394779685898637927c8f5b"
      //       ) {
      //         if (branchId && branchId.length > 0) {
      //           var branchIdCount = branchId.length

      //           for (let i = 0; i < branchIdCount; i++) {
      //             console.log("branchId loop branchId iii", branchId[i])

      //             if (c._id === branchId[i]) {
      //               return {
      //                 label: c.name,
      //                 value: c._id,
      //                 companyId: c.companyId,
      //               }
      //             }
      //           }
      //         }
      //       } else {
      //         return {
      //           label: c.name,
      //           value: c._id,
      //           companyId: c.companyId,
      //         }
      //       }
      //     })

      const employeeList = yield call(
        loadRecordsMetaData,
        "employee_list",
        "post"
      )
      // console.log(branchName, "branchName")
      console.log(employeeList, " my employeelist")
      // console.log(companyDetailsList, " my companyDetailsList")

      let recordsMetaData = {
        companyOptions:
          (company &&
            company.data &&
            company.data.length > 0 &&
            company.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign({}, { label: c.name, value: c._id })
              )) ||
          [],

        branchOptions:
          (branch &&
            branch.data &&
            branch.data.length > 0 &&
            branch.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  { label: c.name, value: c._id, companyId: c.companyId }
                )
              )) ||
          [],
        serviceOptions:
          (service &&
            service.data &&
            service.data.length > 0 &&
            service.data.map((c) =>
              Object.assign(
                {},
                { label: c.service, value: c._id, companyId: c.companyId }
              )
            )) ||
          [],
        sourceOptions:
          (source &&
            source.data &&
            source.data.length > 0 &&
            source.data.map((c) =>
              Object.assign({}, { label: c.sourceName, value: c._id })
            )) ||
          [],
        subSourceOptions:
          (subSource &&
            subSource.data &&
            subSource.data.length > 0 &&
            subSource.data.map((c) =>
              Object.assign(
                {},
                { label: c.subSourceName, value: c._id, sourceId: c.sourceId }
              )
            )) ||
          [],
        countryOptions:
          (country &&
            country.data &&
            country.data.length > 0 &&
            country.data.map((c) =>
              Object.assign(
                {},
                {
                  label: c.name,
                  value: c._id,
                  states: c.states,
                  shortName: c.shortName,
                }
              )
            )) ||
          [],
        stateOptions:
          (state &&
            state.data &&
            state.data.length > 0 &&
            state.data.map((c) =>
              Object.assign({}, { label: c.name, value: c._id })
            )) ||
          [],
        cityOptions:
          (city &&
            city.data &&
            city.data.length > 0 &&
            city.data.map((c) =>
              Object.assign(
                {},
                {
                  label: c.name,
                  value: c._id,
                  sourceId: c.sourceId,
                  stateId: c.state && c.state._id,
                }
              )
            )) ||
          [],
        clientProfileOptions:
          (clientProfile &&
            clientProfile.data &&
            clientProfile.data.length > 0 &&
            clientProfile.data.map((c) =>
              Object.assign({}, { label: c.clientProfile, value: c._id })
            )) ||
          [],
        priorityStatusOptions:
          (priorityStatus &&
            priorityStatus.data &&
            priorityStatus.data.length > 0 &&
            priorityStatus.data.map((c) =>
              Object.assign({}, { label: c.priority, value: c._id })
            )) ||
          [],
        customFieldOptions:
          (customField &&
            customField.data &&
            customField.data.length > 0 &&
            customField.data) ||
          [],
        companyTableOptions:
          (company &&
            company.data &&
            company.data.length > 0 &&
            company.data) ||
          [],
        processStatusOptions:
          (processStatus &&
            processStatus.data &&
            processStatus.data.length > 0 &&
            processStatus.data.map((p) =>
              Object.assign(
                {},
                {
                  label: p.processStatus,
                  value: p.processStatusId,
                  colorCode: p.colorCode,
                }
              )
            )) ||
          [],
        employeeListOptions:
          (employeeList &&
            employeeList.data &&
            employeeList.data.length > 0 &&
            employeeList.data.map((e) =>
              Object.assign(
                {},
                {
                  label: `${e.empCode} - ${e.name}`,
                  value: e._id,
                  empCode: e.empCode,
                  name: e.name,
                }
              )
            )) ||
          [],
      }

      yield put(loadRecordsMetaDataSuccess(recordsMetaData))
    } catch (error) {
      yield put(
        loadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}

function* updateStatusSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { update } = yield race({
      update: take(UPDATE_STATUS),
    })
    const { record = {}, setSubmitting, redirect } = update
    yield call(setSubmitting, true)

    try {
      const result = yield call(updateStatus, record)
      if (result) {
        yield put(updateStatusSuccess(record, "Status Updated Successfully"))
        yield call(redirect)
      } else {
        yield put(updateStatusError("Update Status Records Failed"))
      }
    } catch (error) {
      yield put(
        updateStatusError(
          (error && error.response && error.response.message) ||
            "Update Status Records Failed"
        )
      )
    } finally {
      yield call(setSubmitting, false)
    }
  }
}

function* leadStatusSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { lead } = yield race({
      lead: take(LEAD_STATUS),
    })
    const { record = {}, setSubmitting, redirect } = lead
    yield call(setSubmitting, true)

    try {
      const result = yield call(leadStatus, record)
      if (result) {
        yield put(leadStatusSuccess(record, "Status Updated Successfully"))
        yield call(redirect)
        yield put(loadRecordsAction({ status: "active" }, true))
      } else {
        yield put(leadStatusError("Lead Status Records Failed"))
      }
    } catch (error) {
      yield put(
        leadStatusError(
          (error && error.response && error.response.message) ||
            "Lead Status Records Failed"
        )
      )
    } finally {
      yield call(setSubmitting, false)
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadRecordSaga(),
    loadRecordsSaga(),
    createRecordSaga(),
    editRecordSaga(),
    deleteRecordSaga(),
    loadRecordsMetaDataSaga(),
    updateStatusSaga(),
    leadStatusSaga(),
  ])
}
